import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "zoomIconContent pad3"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(`dropdown-toggle whiteColor availableBox pointer`)
}
const _hoisted_6 = {
  class: "fs14 fw600 arial",
  style: {}
}
const _hoisted_7 = {
  key: 0,
  class: "ml4"
}
const _hoisted_8 = { class: "fs11" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "arial fs12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlackBoxEventMenu = _resolveComponent("BlackBoxEventMenu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.ev && _ctx.ev.type == `event`)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(`${_ctx.eventBgColor} posAb  ${_ctx.provider == `zoom` ? `w10 rad7` : `rad5 w90 pad2`} t${_ctx.ev.systemUpdatedAt} ${
                _ctx.ev.allday ? `op2 noClick` : ``
            } ${_ctx.isSelectingEvent ? `z5 with_shadow` : _ctx.ev.parent_room_id ? `z4 ofh` : `ofh`}`),
          style: _normalizeStyle({
                height: `${(_ctx.ev.duration / 15) * _ctx.CELL_HEIGHT - 3}px`,
                top: `${(_ctx.ev.start_hour * 4 + _ctx.ev.start_min / 15) * _ctx.CELL_HEIGHT + _ctx.alldayHeight}px`,
                left: _ctx.provider == `zoom` ? `0px` : `1%`,
                minWidth: _ctx.provider == `zoom` ? `16px` : ``,
                lineHeight: `12px`,
            }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickEv(_ctx.ev)))
        }, [
          (_ctx.provider == `zoom`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives(_createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/logo/zoom_circle.png`),
                  width: "12",
                  height: "12",
                  class: "fl pointer"
                }, null, 8, _hoisted_3), [
                  [_directive_tooltip, _ctx.ev.account ? _ctx.ev.account.email : ``]
                ]),
                _hoisted_4
              ]))
            : (_openBlock(), _createBlock(_component_Dropdown, {
                key: 1,
                ref: "dropdown",
                "not-close-elements": _ctx.notCloseLi
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_BlackBoxEventMenu, {
                    ref: "BlackBoxEventMenu",
                    ev: _ctx.ev,
                    fromType: _ctx.fromType,
                    onAddEvent: _ctx.addEvent,
                    onChangeAvailableEvent: _ctx.changeAvailableEvent,
                    onChangeIgnoreEvent: _ctx.changeIgnoreEvent,
                    onShowEventDetail: _ctx.showEventDetail,
                    onChangeMaxBookingsNum: _ctx.changeMaxBookingsNum
                  }, null, 8, ["ev", "fromType", "onAddEvent", "onChangeAvailableEvent", "onChangeIgnoreEvent", "onShowEventDetail", "onChangeMaxBookingsNum"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, [
                      (!_ctx.ev.allday)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.ev.title), 1),
                            _hoisted_9,
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.startEndText), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["not-close-elements"]))
        ], 6)
      ]))
    : _createCommentVNode("", true)
}